import { Link } from "@anoki/fse-common/dist";
import "./ActionPoint.scss";

type ActionPointProps = {
  links: Array<Link>;
};

export const ActionPoint = ({ links }: ActionPointProps) => {
  return (
    <div className="action-point">
      {links.map((link, index) => (
        <a className="link" key={index} href={link.link}>
          {link.title}
        </a>
      ))}
    </div>
  );
};
